import { ForwardedRef, forwardRef } from 'react';
import { ListProps } from './List.types';
import { FlatList } from 'react-native';
import useStyle from '../../hooks/useStyle';

function List(
  { contentContainerStyle = {}, columnWrapperStyle = {}, ...rest }: ListProps,
  ref: ForwardedRef<FlatList>,
) {
  const parsedContentContainerStyle = useStyle(contentContainerStyle);
  const parsedColumnWrapperStyle = useStyle(columnWrapperStyle);

  return (
    <FlatList
      ref={ref}
      removeClippedSubviews={false}
      contentContainerStyle={parsedContentContainerStyle}
      columnWrapperStyle={
        Object.keys(parsedColumnWrapperStyle).length
          ? parsedColumnWrapperStyle
          : undefined
      }
      {...rest}
    />
  );
}

export default forwardRef(List);
